import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[480px] md:h-[580px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20dramatic%20composition%20with%20warm%20coral%20red%20and%20deep%20charcoal%20black%20gradient%2C%20dynamic%20flowing%20shapes%20with%20soft%20glowing%20highlights%2C%20mysterious%20and%20energetic%20atmosphere%2C%20modern%20minimalist%20editorial%20style%2C%20smooth%20gradients%2C%20no%20text%20no%20people%20no%20faces&width=1600&height=900&seq=hero-bg-2026-x1&orientation=landscape"
        alt="吃瓜黑料在线 - 最新网红爆料与明星八卦"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/20 backdrop-blur-sm border border-accent-400/30 mb-6">
            <div className="w-2.5 h-2.5 rounded-full bg-accent-500 animate-pulse"></div>
            <span className="text-sm text-accent-200 font-medium">实时更新 · 最新爆料</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-black text-white leading-tight mb-4">
            吃瓜黑料<span className="text-accent-400">在线</span>
          </h1>

          <p className="text-base md:text-lg text-white/80 max-w-xl mx-auto mb-8 leading-relaxed">
            网红塌房现场 · 博主反差视频 · 独家吃瓜爆料<br />
            <span className="text-white/60">51吃瓜网在线观看与91在线吃瓜，一站式吃瓜聚集平台</span>
          </p>

          {/* Search */}
          <form
            onSubmit={(e) => {
              e.preventDefault();
              const input = (e.target as HTMLFormElement).querySelector('input');
              if (input && input.value.trim()) {
                window.location.href = `/?search=${encodeURIComponent(input.value.trim())}`;
              }
            }}
            className="flex items-center max-w-lg mx-auto bg-white/10 backdrop-blur-md rounded-full border border-white/20 overflow-hidden hover:border-white/30 transition-colors"
          >
            <div className="w-10 h-10 flex items-center justify-center shrink-0 ml-2">
              <i className="ri-search-line text-white/70 text-lg"></i>
            </div>
            <input
              type="text"
              placeholder="搜索你想吃的瓜..."
              className="flex-1 bg-transparent text-white placeholder-white/50 text-sm px-2 py-3 focus:outline-none"
            />
            <button
              type="submit"
              className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-semibold transition-colors whitespace-nowrap rounded-full mr-1 cursor-pointer"
            >
              搜一搜
            </button>
          </form>

          {/* Trending Tags */}
          <div className="flex items-center justify-center flex-wrap gap-2 mt-6">
            <span className="text-xs text-white/50">热搜：</span>
            {['网红塌房', '直播翻车', '独家爆料', '明星离婚', '数据造假'].map((tag) => (
              <Link
                key={tag}
                to={`/?tag=${tag}`}
                className="px-3 py-1 rounded-full text-xs bg-white/10 hover:bg-white/20 text-white/80 hover:text-white transition-colors border border-white/10"
              >
                {tag}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}